import isEqual from 'lodash/fp/isEqual.js';
import { createSelectorCreator, lruMemoize } from 'reselect';

const createDeepEqualSelector = createSelectorCreator(lruMemoize, isEqual);

export default createDeepEqualSelector;
